import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    quote: 'Me dio estructura y organización para todo el año de Economía. Ahora planifico en minutos lo que antes me llevaba horas.',
    name: 'Claudia Ramírez',
    role: 'Profesora de Economía, 42 años'
  }, {
    quote: 'Inicié el ciclo escolar con todo preparado. Mis alumnos notaron la diferencia desde la primera clase de microeconomía.',
    name: 'Martín Herrera',
    role: 'Docente de Economía, 38 años'
  }, {
    quote: 'Es práctico, claro y muy completo. Lo uso en tres escuelas diferentes y me ahorra muchísimo tiempo.',
    name: 'Soledad Aguirre',
    role: 'Profesora de Economía, 45 años'
  }, {
    quote: 'Las planificaciones de micro y macroeconomía son excelentes. Por fin tengo criterios claros y profesionales para evaluar.',
    name: 'Federico Torres',
    role: 'Docente de Economía, 35 años'
  }, {
    quote: 'Como estudiante de profesorado, este kit me adelantó años de experiencia. Lo recomiendo a todos mis compañeros.',
    name: 'Valentina Paz',
    role: 'Estudiante de profesorado, 24 años'
  }];
  return <section id="testimonios" className="py-8 sm:py-14 bg-[#0f172a]" data-id="element-218">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-219">
        <div className="text-center mb-6 sm:mb-10" data-id="element-220">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3" data-id="element-221">
            Testimonios de docentes
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-222">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" data-id="element-223">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-224">
              <Quote className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-225" />

              <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-226">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-227" />)}
              </div>

              <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-228">
                "{t.quote}"
              </p>

              <div className="mt-auto" data-id="element-229">
                <p className="text-white font-bold text-xs sm:text-sm" data-id="element-230">
                  {t.name}
                </p>
                <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-231">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}